import React from "react";
import PropTypes from "prop-types";
import './style.css'
import {useSelector} from "react-redux";


const FormButton = props => {

    const {configuration} = useSelector(state => state.globalReducer)

    const {
        label,
        disabled,
        loading,
        onClick,
        color = 'primary',
        isSmall = false,
        isClassic = false,
        extra = null
    } = props

    return (
        <button
            disabled={disabled}
            onClick={e => {
                e.preventDefault()
                onClick()
            }}
            className={`${isSmall ? 'settings__btn' : 'form__btn'} ${loading ? 'passive' : ''} ${disabled ? 'disabled' : ''} ${isClassic ? 'classic-button' : ''} ${extra ? extra : ''} justify-center`}>
            {
                loading ? <div className="loader-logo">
                        <img loading="lazy" src={configuration?.icon} alt={'logo'}/>
                    </div>
                    :
                    <span className={'padding-horiz--1'}>{label}</span>
            }
        </button>
    )


}

FormButton.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
}


export default FormButton
